/**
 * Created by rickborst on 25/04/2017.
 */

class PlaybackRules {

    constructor (options = {}) {
        this.enableCatchUp = options.enableCatchUp || false;
        this.enableCdvr = options.enableCdvr || false;
        this.enableNonPrivilegedRecording = options.enableNonPrivilegedRecording || false;
        this.enableRecordingPlaybackNonEntitledChannel =
             options.enableRecordingPlaybackNonEntitledChannel || false;
        this.enableRestart = options.enableRestart || false;
        this.enableTrickPlay = options.enableTrickPlay || false;
        this.enableStartOver = options.enableStartOver || false;
        this.trickPlayBuffer = options.trickPlayBuffer;
        this.catchUpBuffer = options.catchUpBuffer;

        return this;
    }
}

export default PlaybackRules;


// WEBPACK FOOTER //
// ./src/js/models/playbackrules.js